/**
 * What each "How to group" of Advanced (BI) crosses (CU-869fmk5ge D1): the words of the query sentence and the chart's
 * x-axis title. The x axis is the grouping's column dimension, as the BigQuery DAOs alias it (webback
 * `app/database/big_query/daos/bi/*.py` `axis_alias`): pick-up or capture dates (their unit is "Group by option"),
 * offices, or ACRISS codes for `acriss-provider` (whose series are the providers). The 3D table draws no chart.
 *
 * No imports: `node --test` runs it.
 */

const PICKUP = 'pickup'
const CAPTURE = 'capture'

// series: what each line/row is; x: the columns
export const GROUPINGS = Object.freeze({
	'provider-pickup': { series: 'provider', x: PICKUP },
	'category-pickup': { series: 'category', x: PICKUP },
	'lor-pickup': { series: 'rental length', x: PICKUP },
	'office-pickup': { series: 'office', x: PICKUP },
	'acriss-pickup': { series: 'ACRISS code', x: PICKUP },
	'booking-pickup': { series: CAPTURE, x: PICKUP },
	'office-booking': { series: 'office', x: CAPTURE },
	'provider-booking': { series: 'provider', x: CAPTURE },
	'site-booking': { series: 'site', x: CAPTURE },
	'provider-office': { series: 'provider', x: 'pick-up office' },
	'acriss-provider': { series: 'provider', x: 'ACRISS code' },
	'provider-acriss-office': { is3D: true },
})

const UNIT = { day: 'day', week: 'week', month: 'month' }
const unit = groupBy => UNIT[groupBy] || 'day'

const words = (dim, groupBy) => {
	if (dim === PICKUP) return `pick-up ${unit(groupBy) === 'day' ? 'date' : unit(groupBy)}`
	if (dim === CAPTURE) return `the ${unit(groupBy)} the price was captured`
	return dim
}

/** "by provider and pick-up week" — `null` for an unknown grouping */
export function groupingPhrase(reportType, groupBy) {
	const g = GROUPINGS[reportType]
	if (!g) return null
	if (g.is3D) return 'by provider, ACRISS code and office (3D table)'
	return `by ${words(g.series, groupBy)} and ${words(g.x, groupBy)}`
}

/** The chart's x-axis title for the query shown; `''` when there is no chart or the grouping is unknown */
export function xAxisTitle(reportType, groupBy) {
	const g = GROUPINGS[reportType]
	if (!g || g.is3D) return ''
	if (g.x === PICKUP) return `Pick-up ${unit(groupBy) === 'day' ? 'date' : unit(groupBy)}`
	if (g.x === CAPTURE) return `${unit(groupBy)[0].toUpperCase()}${unit(groupBy).slice(1)} the price was captured`
	return g.x[0].toUpperCase() + g.x.slice(1)
}

export const is3D = reportType => !!GROUPINGS[reportType]?.is3D
